export default "__VITE_ASSET__Cpt0LIo___"